// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071614/js/" + chunkId + "." + {"44":"bf95fc83","225":"10464224","481":"2c63377e","486":"6926a511","770":"be8b9247"}[chunkId] + ".0.24237389972345058.chunk.js";
};